/** Chat Icon with badge */
import { Chat } from '@tunasong/icons'
import type { IconProps } from '@tunasong/icons'
import type { FC } from 'react'
import styles from './chat-badge.module.css'

interface ChatBadgeProps extends IconProps {
  showBadge?: boolean
  /** What the badge counts: open tasks (chat tasks M2.5, GH #3041) */
  count: number
}
export const ChatBadge: FC<ChatBadgeProps> = ({ showBadge = true, count = 0, ...restProps }) =>
  showBadge ? (
    <span className={styles.wrapper}>
      <Chat {...restProps} />
      {count > 0 && <span className={styles.badge}>{count}</span>}
    </span>
  ) : (
    <Chat {...restProps} />
  )
